module.exports = __webpack_public_path__ + "img/fig7.5.d4e13605.png";